import { LedStripIcon } from './LedStripIcon';

/**
 * author: GreenTurtwig
 * id F301BDB9-027C-40D0-A21F-3111A7AB218F
 * name led-strip
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/led-strip.svg
 * tags
 * - Home Automation 
 */
export const LightStripIcon = LedStripIcon;
export default LightStripIcon